export default __webpack_public_path__ + "static/media/Blog7.2f0e2ffb.png";